/**
 * "baselineBill": {
                        "end": "2023-09-20",
                        "start": "2023-08-22",
                        "totalCost": 5185.71,
                        "totalUse": 9337.5
                    },
                    "statusCode": "success",
                    "statusMessage": "Success",
                    "variances": [
 */
export interface BillVarianceData {
  baselineBill?: {
    end: string;
    start: string;
    totalCost: number;
    totalUse: number;
  };
  statusCode?: string;
  statusMessage?: string;
  variances?: VarianceData[];
}

class BillVariance implements BillVarianceData {
  baselineBill?: {
    end: string;
    start: string;
    totalCost: number;
    totalUse: number;
  };
  statusCode?: string;
  statusMessage?: string;
  variances?: VarianceData[];

  constructor(
    baselineBill: {
      end: string;
      start: string;
      totalCost: number;
      totalUse: number;
    } = { end: '', start: '', totalCost: 0, totalUse: 0 },
    statusCode: string = '',
    statusMessage: string = '',
    variances: VarianceData[] = []
  ) {
    this.baselineBill = baselineBill;
    this.statusCode = statusCode;
    this.statusMessage = statusMessage;
    this.variances = variances;
  }
}

export interface VarianceData {
  absoluteVariance?: number;
  category?: string;
  percentageVariance?: number;
}
export class Variance implements VarianceData {
  absoluteVariance?: number;
  category?: string;
  percentageVariance?: number;

  constructor(
    absoluteVariance: number = 0,
    category: string = '',
    percentageVariance: number = 0
  ) {
    this.absoluteVariance = absoluteVariance;
    this.category = category;
    this.percentageVariance = percentageVariance;
  }

}

export default BillVariance;